import { IUploadInfo } from 'views/bulkUpload/UploadCatalog/content/uploadCatalogInfo';

export const downloadTemplateInfo: IUploadInfo = {
  title: 'Selecciona el país donde actualizarás información',
  description: <>Exportaremos todos los SKUs del país seleccionado, con las características que selecciones</>,
  icon: 'layers'
};
